
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[keyword]/montreal",
      function () {
        return require("private-next-pages/[keyword]/montreal.js");
      }
    ]);
  